import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = () => (
  <div dir="ltr" className="min-h-screen bg-gray-50 py-16 px-4">
    <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow p-10">
      <Link to="/" className="text-sm text-purple-600 hover:underline mb-8 inline-block">← Back to home</Link>
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Terms of Service</h1>
      <p className="text-sm text-gray-400 mb-8">Last updated: June 2026</p>

      <section className="space-y-6 text-gray-700 text-sm leading-relaxed">
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">1. Acceptance</h2>
          <p>By purchasing or accessing the "קריירה טכנולוגית" (Tech Career) digital course, you agree to these Terms of Service. If you do not agree, do not complete your purchase.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">2. Product Description</h2>
          <p>This is a <strong>self-paced digital educational course</strong> sold by Shoval Saada (sole proprietor). The course consists of pre-recorded video content, written materials, and digital resources covering 17 technology career paths in Israel. Upon successful payment, you receive personal, non-transferable access to the digital course content.</p>
          <p className="mt-2"><strong>This product does not include any personal coaching, consulting, mentoring, or human services of any kind.</strong> All content is delivered digitally and accessed independently by the purchaser.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">3. Deliverables</h2>
          <p>Upon purchase you receive access to:</p>
          <ul className="list-disc ml-4 mt-1 space-y-1">
            <li>Digital course content covering 17 technology roles</li>
            <li>Written career guides and role descriptions</li>
            <li>Salary data and market insights</li>
            <li>Career assessment resources</li>
          </ul>
          <p className="mt-2">All deliverables are digital and delivered electronically. No physical products are shipped.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">4. License</h2>
          <p>You may access and use the course materials for personal, non-commercial purposes only. Redistribution, resale, or sharing of course content is strictly prohibited.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">5. Modifications</h2>
          <p>Shoval Saada reserves the right to update or modify course content at any time to keep it current and accurate.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">6. Governing Law</h2>
          <p>These terms are governed by the laws of the State of Israel.</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-900 mb-1">7. Contact</h2>
          <p>Questions? Contact us at <a href="mailto:shovalrecruiting@gmail.com" className="text-purple-600 hover:underline">shovalhori@gmail.com</a></p>
        </div>
      </section>
    </div>
  </div>
);

export default TermsPage;
